(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_announcement"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('announcement-countdown')) {
  class AnnouncementCountdown extends HTMLElement {
    connectedCallback() {
      this.durationMinutes = parseInt(this.dataset.duration || '45', 10);
      this.expiredAction = this.dataset.expiredAction || 'message';
      this.expiredMessage =
        this.dataset.expiredMessage || 'This offer has ended.';

      this.storageKey =
        this.dataset.storageKey || 'announcement-sale-countdown';

      this.timerElement = this.querySelector(
        '.announcement-countdown__timer'
      );

      this.expiredElement = this.querySelector(
        '[data-countdown-expired]'
      );

      this.hoursElement = this.querySelector(
        '[data-countdown-hours]'
      )

      this.minutesElement = this.querySelector(
        '[data-countdown-minutes]'
      );

      this.secondsElement = this.querySelector(
        '[data-countdown-seconds]'
      );

      this.setupCountdown();
    }

    disconnectedCallback() {
      this.stopCountdown();
    }

    setupCountdown() {
const storedEndTime = sessionStorage.getItem(this.storageKey);
const storedTimestamp = parseInt(storedEndTime, 10);

if (storedEndTime && storedTimestamp > Date.now()) {
  this.endTime = storedTimestamp;
} else {
  this.endTime =
    Date.now() + this.durationMinutes * 60 * 1000;

  sessionStorage.setItem(
    this.storageKey,
    this.endTime.toString()
  );
}

      this.updateCountdown();

      this.interval = window.setInterval(() => {
        this.updateCountdown();
      }, 1000);
    }

    updateCountdown() {
      const remainingMilliseconds =
        this.endTime - Date.now();

      if (remainingMilliseconds <= 0) {
        this.handleExpired();
        return;
      }

      /*
       * Using ceil means a fresh 45-minute timer starts
       * visually at 45:00 instead of briefly showing 44:59.
       */
      const totalSeconds = Math.ceil(
        remainingMilliseconds / 1000
      );

      const hours = 0;
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;

      if (this.hoursElement) {
        this.hoursElement.textContent = 
        this.padNumber(hours);
      }

      if (this.minutesElement) {
        this.minutesElement.textContent =
          this.padNumber(minutes);
      }

      if (this.secondsElement) {
        this.secondsElement.textContent =
          this.padNumber(seconds);
      }
    }

    handleExpired() {
      this.stopCountdown();

      if (this.hoursElement) {
        this.hoursElement.textContent = '00';
      }

      if (this.minutesElement) {
        this.minutesElement.textContent = '00';
      }

      if (this.secondsElement) {
        this.secondsElement.textContent = '00';
      }

      if (this.expiredAction === 'hide') {
        this.hideCountdown();
        return;
      }

      if (this.timerElement) {
        this.timerElement.hidden = true;
      }

      if (this.expiredElement) {
        this.expiredElement.textContent =
          this.expiredMessage;

        this.expiredElement.hidden = false;
      }
    }

    hideCountdown() {
      this.hidden = true;
    }

    stopCountdown() {
      if (this.interval) {
        window.clearInterval(this.interval);
        this.interval = null;
      }
    }

    padNumber(value) {
      return String(value).padStart(2, '0');
    }
  }

  customElements.define(
    'announcement-countdown',
    AnnouncementCountdown
  );
}
  } catch(e) { console.error(e); }
})();

})();
